import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// images
import financialPlanningImageDesktopWebp from './images/diverse-group-of-women-desktop.webp';
import financialPlanningImageMobileWebp from './images/diverse-group-of-women-mobile.webp';
// styles
import { LinkStyled } from './styles';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='who-we-are-financial-planning-5'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent
      // content
      subHeadingText={<>We believe in <WidowBlock>our communities.</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='link'>
            Where we live and the communities we build are at the core of who we are. That&#39;s why we believe in giving back. Together with our partners we&#39;re improving education, revitalizing neighborhoods, and accelerating the search for better treatments and cures for childhood cancer. Since 2012, we&#39;ve contributed more than &#36;40 million and funded over 500,000 hours of childhood cancer research.
          </Typography>
          <LinkStyled
            id='who-we-are-register-link'
            variant='buttonLinkTertiary'
            endAdornment={CaratRight}
            endAdornmentStylesReset
            linkUrl='/philanthropy/'>
            More about our philanthropy
          </LinkStyled>
        </>
      )}
      // image props
      imageAltText='A diverse group of women.'
      imageSrcDefault={financialPlanningImageDesktopWebp}
      imageSrcMobile={financialPlanningImageMobileWebp}
    />
  );
};
